import { IComment } from '../../core/helpers/interfaces/comment';
import {
	GET_SHARED_SNAP,
	GET_SHARED_SNAP_SUCCESS,
	GET_SHARED_SNAP_FAILURE,
	ADD_COMMENT_TO_SHARED_SUCCESS,
} from './types';

export const getSharedSnapAction = (payload: string) => ({
	type: GET_SHARED_SNAP,
	payload,
});

export const getSharedSnapSuccessAction = (payload: any) => ({
	type: GET_SHARED_SNAP_SUCCESS,
	payload,
});

export const getSharedSnapFailureAction = (error: Error) => ({
	type: GET_SHARED_SNAP_FAILURE,
	payload: error,
});

export const addCommentToSharedAction = (payload: IComment) => ({
	type: ADD_COMMENT_TO_SHARED_SUCCESS,
	payload,
});
